const options1 = {
  root: null, // use the viewport as the root
  rootMargin: "0px", // no margin
  threshold: 0.5 // 50% of the target element must be visible
};

// Select all image wrappers
const imageWrappers = document.querySelectorAll(".image-with-text__vertical-slider .left-side .image-wrapper");

function callback(entries, observer) {
  entries.forEach((entry) => {
    const currentContentWrapper = entry.target;
    const index = parseInt(currentContentWrapper.dataset.index);

    if (entry.isIntersecting) {
      currentContentWrapper.classList.add("in-view");

      if (imageWrappers[index]) {
        imageWrappers[index].classList.add("show");
        for (let i = index + 1; i < imageWrappers.length; i++) {
          imageWrappers[i].classList.remove("show");
        }
      }
    } else {
      currentContentWrapper.classList.remove("in-view");
    }
  });
}

// Interaction Observer for each content section (right side)
const observer = new IntersectionObserver(callback, options1);
const contentWrappers = document.querySelectorAll(".image-with-text__vertical-slider .right-side .content-wrapper");

contentWrappers.forEach((wrapper) => {
  observer.observe(wrapper);
});


// Mobile slider
const mobileSlider = document.querySelector('.image-with-text-scrolling-mobile__slider');

if (mobileSlider) {
  // Initialize Flickity
  let flkty = new Flickity(mobileSlider, {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    groupCells: true,
  });
}
